import { render, staticRenderFns } from "./ConcessionRequest.vue?vue&type=template&id=4fc6da02"
import script from "./ConcessionRequest.vue?vue&type=script&lang=js"
export * from "./ConcessionRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports